import React, { PureComponent } from 'react';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Multiselect } from 'react-widgets';
import Modal from 'react-modal';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from '../../../services/fetchTools';
import {
  colors,
  shadows,
  btn,
  breadcrumb,
  form,
} from '../../../style/common/partnerStyle';

function compressToWebP(file, maxDimension, quality) {
  maxDimension = maxDimension || 1200;
  quality = quality || 0.82;
  return new Promise(function(resolve) {
    var reader = new FileReader();
    reader.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round((height / width) * maxDimension);
            width = maxDimension;
          } else {
            width = Math.round((width / height) * maxDimension);
            height = maxDimension;
          }
        }
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          function(blob) {
            if (!blob) {
              resolve({ file: file, compressed: false, preview: e.target.result });
              return;
            }
            if (blob.size >= file.size) {
              var preview = URL.createObjectURL(file);
              resolve({ file: file, compressed: false, preview: preview });
            } else {
              var webpFile = new File([blob], file.name.replace(/\.[^.]+$/, '.webp'), { type: 'image/webp' });
              var preview = URL.createObjectURL(webpFile);
              resolve({ file: webpFile, compressed: true, originalSize: file.size, compressedSize: webpFile.size, preview: preview });
            }
          },
          'image/webp',
          quality
        );
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

function formatBytes(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
}

var STEPS = [
  { label: 'Recipients',   icon: '👥' },
  { label: 'Message',      icon: '✍️'  },
  { label: 'Media & Push', icon: '🔔' },
  { label: 'Review',       icon: '✅' },
];

var PROGRAMS = [
  { value: 8,  label: 'Football Academy'  },
  { value: 10, label: 'Badminton Academy' },
  { value: 65, label: 'Swimming Academy'  },
];

var modalStyles = {
  overlay: {
    background: 'rgba(11,17,32,0.6)',
    backdropFilter: 'blur(4px)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative',
    inset: 'auto',
    padding: 0,
    border: 'none',
    borderRadius: 20,
    boxShadow: '0 24px 64px rgba(0,0,0,0.28)',
    width: '92%',
    maxWidth: 440,
    maxHeight: '90vh',
    overflow: 'auto',
    background: 'transparent',
  },
};

class SendAnnouncements extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      step: 1,
      cities: [],
      venues: [],
      selectedCities: [],
      filteredVenues: [],
      selectedVenues: [],
      selectedProgram: '',
      messageTitle: '',
      messageBody: EditorState.createEmpty(),
      url: '',
      action_item_label: '',
      image: '',
      imagePreview: null,
      imageCompressInfo: null,
      imageIsCompressing: false,
      documents: '',
      venueSelectionType: 'all',
      citySelectionType: 'all',
      recipientCount: '',
      sendNotification: true,
      notification_message: '',
      notification_title: '',
      isSubmitting: false,
      openPreview: false,
    };
    this.onProgramChange = this.onProgramChange.bind(this);
    this.filterVenuesByCities = this.filterVenuesByCities.bind(this);
    this.getHtmlContent = this.getHtmlContent.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.onRecipientSubmit = this.onRecipientSubmit.bind(this);
    this.onMessageSubmit = this.onMessageSubmit.bind(this);
    this.onActionSubmit = this.onActionSubmit.bind(this);
    this.onSubmitData = this.onSubmitData.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.renderRecipients = this.renderRecipients.bind(this);
    this.renderMessage = this.renderMessage.bind(this);
    this.renderActionAndNotification = this.renderActionAndNotification.bind(this);
    this.renderSummary = this.renderSummary.bind(this);
  }

  getVenues() {
    var self = this;
    var url = getLocationOrigin() + '/business/get_venues_for_buddies/?game_type_id=' + this.state.selectedProgram;
    return fetch(url, Object.assign({}, defaultOptions))
      .then(checkStatus).then(parseJSON)
      .then(function(data) { self.setState({ cities: data.cities, venues: data.result, filteredVenues: data.result }); })
      .catch(function(err) { return err; });
  }

  getRecipientCount() {
    var self = this;
    var city_list = this.state.selectedCities.map(function(c) { return c.id; });
    var venue_list = this.state.selectedVenues.map(function(v) { return v.id; });
    var url = getLocationOrigin() + '/notification/get_active_customers_for_announcement/?cities=' + city_list + '&venues=' + venue_list + '&game_type=' + this.state.selectedProgram;
    return fetch(url, Object.assign({}, defaultOptions))
      .then(checkStatus).then(parseJSON)
      .then(function(data) { self.setState({ recipientCount: data.count }); })
      .catch(function(err) { return err; });
  }

  filterVenuesByCities() {
    var ids = this.state.selectedCities.map(function(c) { return c.id; });
    this.setState({
      filteredVenues: this.state.venues.filter(function(v) { return ids.indexOf(v.city) !== -1; }),
      selectedVenues: this.state.selectedVenues.filter(function(v) { return ids.indexOf(v.city) !== -1; }),
    });
  }

  onProgramChange(e) {
    this.setState({
      selectedProgram: e.target.value,
      citySelectionType: 'all', selectedCities: [],
      selectedVenues: [], venueSelectionType: 'all',
    }, function() { this.getVenues(); }.bind(this));
  }

  getHtmlContent() {
    return draftToHtml(convertToRaw(this.state.messageBody.getCurrentContent()));
  }

  onEditorStateChange(messageBody) {
    this.setState({ messageBody: messageBody });
  }

  handleImageUpload(e) {
    var file = e.target.files[0];
    if (!file) return;
    var self = this;
    this.setState({ imageIsCompressing: true, imageCompressInfo: null });
    compressToWebP(file).then(function(result) {
      self.setState({
        image: result.file,
        imagePreview: result.preview,
        imageCompressInfo: result,
        imageIsCompressing: false,
      });
    }).catch(function() {
      self.setState({
        image: file,
        imagePreview: URL.createObjectURL(file),
        imageCompressInfo: { compressed: false },
        imageIsCompressing: false,
      });
    });
  }

  nextStep() {
    var step = this.state.step;
    if      (step === 1) this.onRecipientSubmit();
    else if (step === 2) this.onMessageSubmit();
    else if (step === 3) this.onActionSubmit();
    else if (step === 4) this.onSubmitData();
  }

  prevStep() {
    this.setState(function(p) { return { step: p.step - 1 }; });
  }

  onRecipientSubmit() {
    var s = this.state;
    if (!s.selectedProgram)                                              return alert('Please choose a program');
    if (s.citySelectionType === 'specific' && !s.selectedCities.length) return alert('Please choose a city or select All');
    if (s.venueSelectionType === 'specific' && !s.selectedVenues.length) return alert('Please choose a venue or select All');
    this.getRecipientCount();
    this.setState(function(p) { return { step: p.step + 1 }; });
  }

  onMessageSubmit() {
    var s = this.state;
    if (!s.messageTitle)                              return alert('Please enter a title');
    if (!s.messageBody.getCurrentContent().hasText()) return alert('Please enter the message body');
    this.setState(function(p) { return { step: p.step + 1 }; });
  }

  onActionSubmit() {
    var s = this.state;
    if (s.sendNotification && (!s.notification_title || !s.notification_message))
      return alert('Please enter both notification title and message');
    this.setState(function(p) { return { step: p.step + 1 }; });
  }

  onSubmitData() {
    var self = this;
    this.setState({ isSubmitting: true });
    var s = this.state;
    var formData = new FormData();
    formData.append('title', s.messageTitle);
    formData.append('body', this.getHtmlContent());
    formData.append('url', s.url);
    formData.append('action_item_label', s.action_item_label);
    formData.append('image', s.image);
    formData.append('document', s.documents);
    formData.append('cities', s.selectedCities.map(function(c) { return c.id; }));
    formData.append('venues', s.selectedVenues.map(function(v) { return v.id; }));
    formData.append('game_type_id', s.selectedProgram);
    formData.append('send_notification', s.sendNotification);
    formData.append('notification_title', s.notification_title);
    formData.append('notification_message', s.notification_message);
    var url = getLocationOrigin() + '/notification/create_announcement/';
    var options = Object.assign({}, defaultOptions, { method: 'post', body: formData });
    fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(function(data) {
        alert(data.message);
        if (data.success) self.props.history.goBack();
      })
      .catch(function(err) { alert(err.message); })
      .then(function() { self.setState({ isSubmitting: false }); });
  }

  renderRecipients() {
    var self = this;
    var s = this.state;
    return (
      <div style={S.stepBody}>
        <FieldGroup>
          <FieldLabel>Program</FieldLabel>
          <select value={s.selectedProgram || ''} onChange={this.onProgramChange} style={form.select}>
            <option value="">Choose a program…</option>
            {PROGRAMS.map(function(p) { return <option key={p.value} value={p.value}>{p.label}</option>; })}
          </select>
        </FieldGroup>

        {s.selectedProgram && (
          <FieldGroup>
            <FieldLabel>City scope</FieldLabel>
            <RadioGroup
              name="cityType"
              options={[{ value: 'all', label: 'All cities' }, { value: 'specific', label: 'Specific cities' }]}
              value={s.citySelectionType}
              onChange={function(v) { self.setState({ citySelectionType: v, selectedCities: [], selectedVenues: [], venueSelectionType: 'all' }); }}
            />
          </FieldGroup>
        )}

        {s.citySelectionType === 'specific' && (
          <FieldGroup>
            <FieldLabel>Cities</FieldLabel>
            <div style={{ flex: 1 }}>
              <Multiselect
                data={s.cities}
                value={s.selectedCities}
                textField="name"
                valueField="id"
                onChange={function(selected) { self.setState({ selectedCities: selected }, self.filterVenuesByCities); }}
                placeholder="Select cities…"
                filter="contains"
              />
            </div>
          </FieldGroup>
        )}

        {s.citySelectionType === 'specific' && s.selectedCities.length > 0 && (
          <FieldGroup>
            <FieldLabel>Venue scope</FieldLabel>
            <RadioGroup
              name="venueType"
              options={[{ value: 'all', label: 'All venues' }, { value: 'specific', label: 'Specific venues' }]}
              value={s.venueSelectionType}
              onChange={function(v) { self.setState({ venueSelectionType: v, selectedVenues: [] }); }}
            />
          </FieldGroup>
        )}

        {s.citySelectionType === 'specific' && s.venueSelectionType === 'specific' && s.selectedCities.length > 0 && (
          <FieldGroup>
            <FieldLabel>Venues</FieldLabel>
            <div style={{ flex: 1 }}>
              <Multiselect
                data={s.filteredVenues}
                value={s.selectedVenues}
                textField="name"
                valueField="id"
                onChange={function(selected) { self.setState({ selectedVenues: selected }); }}
                placeholder="Select venues…"
                filter="contains"
              />
            </div>
          </FieldGroup>
        )}
      </div>
    );
  }

  renderMessage() {
    var self = this;
    var s = this.state;
    return (
      <div style={S.stepBody}>
        <FieldGroup>
          <FieldLabel>Title</FieldLabel>
          <input
            type="text"
            value={s.messageTitle}
            onChange={function(e) { self.setState({ messageTitle: e.target.value }); }}
            style={form.input}
            placeholder="Enter announcement title…"
          />
        </FieldGroup>
        <div style={S.editorFieldRow}>
          <FieldLabel style={{ paddingTop: 10 }}>Body</FieldLabel>
          <div style={S.editorWrap}>
            <Editor
              editorState={s.messageBody}
              onEditorStateChange={this.onEditorStateChange}
              wrapperStyle={{ margin: 0 }}
              editorStyle={{ minHeight: 200, padding: '10px 14px', fontSize: 14, lineHeight: 1.6 }}
              toolbar={{
                options: ['inline', 'blockType', 'list', 'link', 'emoji', 'history'],
                inline: { options: ['bold', 'italic', 'underline'] },
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderActionAndNotification() {
    var self = this;
    var s = this.state;
    return (
      <div style={S.stepBody}>
        <SectionLabel icon="🔗">Action Button <span style={S.optTag}>optional</span></SectionLabel>
        <FieldGroup>
          <FieldLabel>Link URL</FieldLabel>
          <input type="text" value={s.url}
            onChange={function(e) { self.setState({ url: e.target.value }); }}
            style={form.input} placeholder="https://…" />
        </FieldGroup>
        <FieldGroup>
          <FieldLabel>Button label</FieldLabel>
          <input type="text" value={s.action_item_label}
            onChange={function(e) { self.setState({ action_item_label: e.target.value }); }}
            style={form.input} placeholder="e.g. Register Now" />
        </FieldGroup>

        <div style={S.divider} />

        <SectionLabel icon="🖼">Media <span style={S.optTag}>optional</span></SectionLabel>

        <FieldGroup style={{ alignItems: 'flex-start' }}>
          <FieldLabel style={{ paddingTop: 8 }}>Banner</FieldLabel>
          <div style={{ flex: 1 }}>
            <label style={S.uploadLabel}>
              <input
                type="file"
                accept="image/*"
                onChange={this.handleImageUpload}
                style={{ display: 'none' }}
              />
              {s.imageIsCompressing ? (
                <div style={S.uploadCompressing}>
                  <span style={S.spinnerSmall} />
                  <span style={{ fontSize: 12, color: colors.muted }}>Compressing image…</span>
                </div>
              ) : s.imagePreview ? (
                <div style={S.uploadPreviewWrap} className="upload-preview-wrap">
                  <img src={s.imagePreview} alt="Preview" style={S.uploadPreviewImg} />
                  <div style={S.uploadPreviewOverlay} className="upload-overlay">
                    <span style={{ fontSize: 11, color: '#fff', fontWeight: 600 }}>Click to replace</span>
                  </div>
                </div>
              ) : (
                <div style={S.uploadEmpty}>
                  <span style={{ fontSize: 26 }}>📷</span>
                  <span style={{ fontSize: 13, color: colors.brand, fontWeight: 600 }}>Choose image</span>
                  <span style={{ fontSize: 11, color: colors.muted }}>PNG, JPG, WEBP · auto-compressed</span>
                </div>
              )}
            </label>

            {s.imageCompressInfo && !s.imageIsCompressing && (
              <div style={Object.assign({}, S.compressBadge, s.imageCompressInfo.compressed ? {
                background: '#d5f5ec', color: '#0e9f6e', borderColor: '#6ee7b7',
              } : {
                background: '#f3f4f6', color: colors.muted, borderColor: colors.border,
              })}>
                {s.imageCompressInfo.compressed
                  ? <span>✓ WebP &nbsp;·&nbsp; {formatBytes(s.imageCompressInfo.originalSize)} → {formatBytes(s.imageCompressInfo.compressedSize)} &nbsp;·&nbsp; <strong>−{Math.round((1 - s.imageCompressInfo.compressedSize / s.imageCompressInfo.originalSize) * 100)}%</strong></span>
                  : <span>Original used (already optimal)</span>
                }
              </div>
            )}
          </div>
        </FieldGroup>

        <FieldGroup>
          <FieldLabel>Document</FieldLabel>
          <label style={Object.assign({ flex: 1 }, S.docUploadLabel)}>
            <input type="file"
              onChange={function(e) { self.setState({ documents: e.target.files[0] }); }}
              style={{ display: 'none' }} />
            <span style={{ fontSize: 13 }}>
              {s.documents
                ? <span style={{ color: colors.text, fontWeight: 600 }}>📄 {s.documents.name}</span>
                : <span style={{ color: colors.muted }}>📎 Attach a document…</span>
              }
            </span>
            <span style={{ fontSize: 11, color: colors.brand, fontWeight: 600 }}>Browse</span>
          </label>
        </FieldGroup>

        <div style={S.divider} />

        <SectionLabel icon="🔔">Push Notification</SectionLabel>

        <FieldGroup>
          <FieldLabel>Send push</FieldLabel>
          <Toggle
            checked={s.sendNotification}
            onChange={function(v) { self.setState({ sendNotification: v }); }}
          />
        </FieldGroup>

        {s.sendNotification && (
          <div style={S.pushFields}>
            <FieldGroup>
              <FieldLabel>Push title</FieldLabel>
              <input type="text" value={s.notification_title}
                onChange={function(e) { self.setState({ notification_title: e.target.value }); }}
                style={form.input} placeholder="Push notification title…" />
            </FieldGroup>
            <FieldGroup>
              <FieldLabel>Push message</FieldLabel>
              <input type="text" value={s.notification_message}
                onChange={function(e) { self.setState({ notification_message: e.target.value }); }}
                style={form.input} placeholder="Short, snappy message…" />
            </FieldGroup>
          </div>
        )}
      </div>
    );
  }

  renderSummary() {
    var self = this;
    var s = this.state;
    var programMatch = PROGRAMS.filter(function(p) { return p.value == s.selectedProgram; });
    var programLabel = programMatch.length ? programMatch[0].label : '—';
    var citiesLabel  = s.citySelectionType === 'all' ? 'All cities' : s.selectedCities.map(function(c) { return c.name; }).join(', ');
    var venuesLabel  =
      s.citySelectionType === 'all'  ? 'All venues' :
      s.venueSelectionType === 'all' ? 'All venues in ' + s.selectedCities.map(function(c) { return c.name; }).join(', ') :
                                       s.selectedVenues.map(function(v) { return v.name; }).join(', ');

    var rows = [
      { label: 'Program',    value: programLabel },
      { label: 'Cities',     value: citiesLabel  },
      { label: 'Venues',     value: venuesLabel  },
      { label: 'Title',      value: s.messageTitle },
      { label: 'Recipients', value: <span style={{ fontWeight: 700, color: colors.brand, fontSize: 15 }}>{s.recipientCount || '—'}</span> },
    ];

    return (
      <div style={S.stepBody}>
        <div style={S.summaryCard}>
          <div style={S.summaryCardHeader}>
            <span style={{ fontWeight: 700, fontSize: 13, color: colors.text }}>Announcement Overview</span>
          </div>
          {rows.map(function(row) {
            return (
              <div key={row.label} style={S.summaryRow}>
                <span style={S.summaryLabel}>{row.label}</span>
                <span style={S.summaryValue}>{row.value}</span>
              </div>
            );
          })}
        </div>

        <button style={Object.assign({}, btn.outline, { gap: 7, alignSelf: 'flex-start' })}
          onClick={function() { self.setState({ openPreview: true }); }}>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
            <ellipse cx="7.5" cy="7.5" rx="6.5" ry="4.5" stroke="currentColor" strokeWidth="1.4"/>
            <circle cx="7.5" cy="7.5" r="2.2" fill="currentColor"/>
          </svg>
          Preview message
        </button>

        {s.sendNotification && (
          <div style={S.pushSummaryCard}>
            <div style={S.pushSummaryHeader}>
              <div style={S.pushSummaryIcon}>🔔</div>
              <span style={{ fontSize: 12, fontWeight: 700, color: colors.text, letterSpacing: '0.02em' }}>Push Notification</span>
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: colors.text, marginBottom: 3 }}>
              {s.notification_title || <span style={{ color: colors.muted, fontStyle: 'italic' }}>No title</span>}
            </div>
            <div style={{ fontSize: 13, color: colors.muted, lineHeight: 1.5 }}>
              {s.notification_message || <span style={{ fontStyle: 'italic' }}>No message</span>}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderPreview() {
    var self = this;
    var s = this.state;
    return (
      <Modal isOpen={s.openPreview} onRequestClose={function() { self.setState({ openPreview: false }); }} style={modalStyles}>
        <div style={S.previewShell}>
          <div style={S.previewBar}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={S.previewFakeNotch} />
              <span style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.9)', letterSpacing: '0.04em' }}>PREVIEW</span>
            </div>
            <button onClick={function() { self.setState({ openPreview: false }); }} style={S.previewClose}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
          <div style={S.previewBody}>
            {s.imagePreview
              ? <img src={s.imagePreview} alt="Banner" style={S.previewImg} />
              : <div style={S.previewImgPlaceholder}><span style={{ fontSize: 32, opacity: 0.4 }}>🖼</span></div>
            }
            <div style={S.previewContent}>
              <h3 style={S.previewTitle}>{s.messageTitle || 'Untitled Announcement'}</h3>
              <div
                className="ann-preview-body"
                style={{ fontSize: 14, lineHeight: 1.7, color: colors.text }}
                dangerouslySetInnerHTML={{ __html: this.getHtmlContent() }}
              />
              {s.action_item_label && (
                <div style={{ marginTop: 20, textAlign: 'center' }}>
                  <button style={Object.assign({}, btn.primary, { padding: '10px 24px', borderRadius: 99 })}>
                    {s.action_item_label}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderStepHeader() {
    var step = this.state.step;
    return (
      <div style={S.stepHeader}>
        {STEPS.map(function(s, i) {
          var n      = i + 1;
          var active = step === n;
          var done   = step > n;
          return (
            <div key={s.label} style={{ display: 'flex', alignItems: 'flex-start', flex: i < STEPS.length - 1 ? 1 : 'none' }}>
              <div style={S.stepItem}>
                <div style={Object.assign({}, S.stepCircle, {
                  background: done ? colors.success : active ? colors.brand : '#e5e7eb',
                  color: done || active ? '#fff' : '#9ca3af',
                  boxShadow: active ? '0 0 0 4px ' + colors.brand + '33' : 'none',
                })}>
                  {done
                    ? <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1.5 6l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    : n
                  }
                </div>
                <span style={Object.assign({}, S.stepLabel, {
                  fontWeight: active ? 700 : 500,
                  color: active ? colors.brand : done ? colors.success : '#9ca3af',
                })}>
                  {s.label}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div style={Object.assign({}, S.stepConnector, {
                  background: done ? colors.success : '#e5e7eb',
                })} />
              )}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    var self = this;
    var s = this.state;
    var stepContent = [
      this.renderRecipients,
      this.renderMessage,
      this.renderActionAndNotification,
      this.renderSummary,
    ];

    return (
      <div style={S.page}>
        <style>{
          '@keyframes spin { to { transform: rotate(360deg); } }' +
          '@keyframes fadeSlideIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }' +
          '.rdw-editor-wrapper { font-family: DM Sans,Segoe UI,sans-serif; }' +
          '.rdw-toolbar-wrapper { border-bottom: 1px solid ' + colors.border + ' !important; background: ' + colors.bg + ' !important; border-radius: 0 !important; padding: 6px 10px !important; }' +
          '.rw-multiselect { font-family: DM Sans,Segoe UI,sans-serif; font-size: 13px; }' +
          '.rw-widget-container { border-color: ' + colors.border + ' !important; border-radius: 8px !important; }' +
          '.ann-preview-body p { margin: 0 0 12px; }' +
          '.ann-preview-body ul { padding-left: 18px; }' +
          '.step-content { animation: fadeSlideIn 0.22s ease; }' +
          '.upload-preview-wrap:hover .upload-overlay { opacity: 1 !important; }'
        }</style>

        <div style={breadcrumb.wrap}>
          <a href="/#/announcements" style={breadcrumb.link}>Announcements</a>
          <span style={breadcrumb.separator}> › </span>
          <span style={breadcrumb.current}>Create Announcement</span>
        </div>

        <div style={S.formWrap}>
          <div style={S.cardHeader}>
            <div style={S.cardHeaderLeft}>
              <div style={S.cardHeaderIcon}>📢</div>
              <div>
                <h2 style={S.cardTitle}>Create Announcement</h2>
                <p style={S.cardSubtitle}>Send a message to your academy members</p>
              </div>
            </div>
            <div style={S.stepPill}>Step {s.step} of {STEPS.length}</div>
          </div>

          <div style={{ padding: '28px 28px 0' }}>
            {this.renderStepHeader()}
          </div>

          <div className="step-content" key={s.step}>
            {stepContent[s.step - 1].call(this)}
          </div>

          <div style={S.footer}>
            {s.step > 1
              ? <button style={btn.cancel} onClick={this.prevStep}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginRight: 4 }}>
                    <path d="M8 1L3 6l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Back
                </button>
              : <div />
            }

            {s.step < 4
              ? <button style={btn.primary} onClick={this.nextStep}>
                  Continue
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginLeft: 4 }}>
                    <path d="M4 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              : <button
                  style={Object.assign({}, btn.primary, { opacity: s.isSubmitting ? 0.65 : 1, cursor: s.isSubmitting ? 'not-allowed' : 'pointer' })}
                  onClick={this.nextStep}
                  disabled={s.isSubmitting}
                >
                  {s.isSubmitting
                    ? <span><span style={S.spinnerWhite} />Sending…</span>
                    : <span>
                        <svg width="13" height="13" viewBox="0 0 14 14" fill="none" style={{ marginRight: 4, verticalAlign: 'middle' }}>
                          <path d="M1 7l4 4L13 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Send Announcement
                      </span>
                  }
                </button>
            }
          </div>
        </div>

        {s.openPreview && this.renderPreview()}
      </div>
    );
  }
}

function FieldGroup(props) {
  return <div style={Object.assign({}, S.fieldRow, props.style || {})}>{props.children}</div>;
}

function FieldLabel(props) {
  return <span style={Object.assign({}, form.label, props.style || {})}>{props.children}</span>;
}

function SectionLabel(props) {
  return (
    <div style={S.sectionLabel}>
      {props.icon && <span style={{ fontSize: 14 }}>{props.icon}</span>}
      <span>{props.children}</span>
    </div>
  );
}

function RadioGroup(props) {
  return (
    <div style={{ display: 'flex', gap: 10, flex: 1, flexWrap: 'wrap' }}>
      {props.options.map(function(opt) {
        var active = props.value === opt.value;
        return (
          <label key={opt.value} style={{
            display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
            padding: '7px 14px', borderRadius: 8,
            border: '1.5px solid ' + (active ? colors.brand : colors.border),
            background: active ? colors.brandLt : '#fff',
            userSelect: 'none',
          }}>
            <input type="radio" name={props.name} value={opt.value}
              checked={active} onChange={function() { props.onChange(opt.value); }}
              style={{ display: 'none' }} />
            <div style={{
              width: 14, height: 14, borderRadius: '50%',
              border: '2px solid ' + (active ? colors.brand : '#d1d5db'),
              background: active ? colors.brand : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              {active && <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#fff' }} />}
            </div>
            <span style={{ fontSize: 13, fontWeight: active ? 600 : 400, color: colors.text }}>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}

function Toggle(props) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <button
        type="button"
        onClick={function() { props.onChange(!props.checked); }}
        style={{
          width: 44, height: 24, borderRadius: 99, border: 'none',
          background: props.checked ? colors.brand : '#d1d5db',
          cursor: 'pointer', position: 'relative',
          padding: 0, flexShrink: 0,
        }}
      >
        <div style={{
          position: 'absolute', top: 3,
          left: props.checked ? 23 : 3,
          width: 18, height: 18, borderRadius: '50%', background: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
          transition: 'left 0.2s',
        }} />
      </button>
      <span style={{ fontSize: 13, fontWeight: 600, color: props.checked ? colors.brand : colors.muted }}>
        {props.checked ? 'Enabled' : 'Disabled'}
      </span>
    </div>
  );
}

var S = {
  page: {
    fontFamily: "'DM Sans','Segoe UI',sans-serif",
    background: colors.bg,
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  formWrap: {
    background: colors.surface,
    borderRadius: 16,
    boxShadow: shadows.card,
    margin: '0 20px 40px',
    overflow: 'hidden',
    border: '1px solid ' + colors.border,
  },
  cardHeader: {
    background: 'linear-gradient(135deg, ' + colors.brand + ' 0%, #2563eb 100%)',
    padding: '22px 28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  cardHeaderIcon: {
    width: 44, height: 44, borderRadius: 12,
    background: 'rgba(255,255,255,0.18)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 22,
  },
  cardTitle: {
    margin: 0, fontSize: 17, fontWeight: 700, color: '#fff',
  },
  cardSubtitle: {
    margin: '2px 0 0', fontSize: 12, color: 'rgba(255,255,255,0.72)', fontWeight: 400,
  },
  stepPill: {
    background: 'rgba(255,255,255,0.18)',
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
    padding: '5px 12px',
    borderRadius: 99,
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
  },
  stepHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 28,
  },
  stepItem: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0,
  },
  stepLabel: {
    fontSize: 11,
    marginTop: 7,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  stepCircle: {
    width: 32, height: 32, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 13, fontWeight: 700,
  },
  stepConnector: {
    flex: 1, height: 2, marginTop: 15,
  },
  stepBody: {
    padding: '4px 28px 24px',
    display: 'flex', flexDirection: 'column', gap: 14,
  },
  fieldRow: {
    display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
  },
  editorFieldRow: {
    display: 'flex', alignItems: 'flex-start', gap: 12,
  },
  editorWrap: {
    flex: 1,
    border: '1px solid ' + colors.border,
    borderRadius: 10,
    overflow: 'hidden',
    background: '#fff',
  },
  divider: {
    borderTop: '1px solid ' + colors.border,
    margin: '4px 0',
  },
  sectionLabel: {
    display: 'flex', alignItems: 'center', gap: 7,
    fontSize: 11, fontWeight: 700, textTransform: 'uppercase',
    letterSpacing: '0.07em', color: colors.muted,
    paddingBottom: 8, borderBottom: '1px solid ' + colors.border,
  },
  optTag: {
    fontSize: 10, fontWeight: 500, textTransform: 'lowercase',
    letterSpacing: 0, color: '#d1d5db',
  },
  uploadLabel: {
    display: 'block', cursor: 'pointer', borderRadius: 10, overflow: 'hidden',
  },
  uploadEmpty: {
    height: 120, border: '2px dashed ' + colors.border, borderRadius: 10,
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    gap: 6, background: colors.bg,
  },
  uploadCompressing: {
    height: 120, border: '2px dashed ' + colors.brand + '44', borderRadius: 10,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
    background: colors.brandLt,
  },
  uploadPreviewWrap: {
    position: 'relative', borderRadius: 10, overflow: 'hidden',
    border: '1px solid ' + colors.border,
  },
  uploadPreviewImg: {
    width: '100%', height: 160, objectFit: 'cover', display: 'block',
  },
  uploadPreviewOverlay: {
    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  compressBadge: {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    marginTop: 8, padding: '5px 12px', borderRadius: 99,
    fontSize: 11, fontWeight: 600, border: '1px solid',
  },
  docUploadLabel: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    cursor: 'pointer', padding: '10px 14px',
    border: '1px solid ' + colors.border, borderRadius: 8,
    background: '#fff',
  },
  pushFields: {
    background: colors.bg,
    borderRadius: 10, border: '1px solid ' + colors.border,
    padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10,
  },
  summaryCard: {
    border: '1px solid ' + colors.border, borderRadius: 12, overflow: 'hidden',
  },
  summaryCardHeader: {
    background: colors.bg, padding: '10px 16px',
    borderBottom: '1px solid ' + colors.border,
  },
  summaryRow: {
    display: 'flex', padding: '12px 16px',
    borderBottom: '1px solid ' + colors.border, gap: 12,
  },
  summaryLabel: {
    width: 110, flexShrink: 0,
    fontSize: 11, fontWeight: 700, color: colors.muted,
    textTransform: 'uppercase', letterSpacing: '0.05em', paddingTop: 1,
  },
  summaryValue: {
    fontSize: 13, color: colors.text, flex: 1, wordBreak: 'break-word',
  },
  pushSummaryCard: {
    background: '#f0f7ff', border: '1px solid #bfdbfe',
    borderRadius: 12, padding: '14px 16px',
  },
  pushSummaryHeader: {
    display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10,
  },
  pushSummaryIcon: {
    width: 28, height: 28, borderRadius: 8,
    background: colors.brandLt, display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14,
  },
  footer: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '16px 28px', borderTop: '1px solid ' + colors.border,
    background: colors.bg,
  },
  previewShell: {
    background: '#f0f4f8', borderRadius: 20, overflow: 'hidden',
  },
  previewBar: {
    background: 'linear-gradient(135deg, ' + colors.brand + ', #2563eb)',
    padding: '14px 18px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  },
  previewFakeNotch: {
    width: 40, height: 5, borderRadius: 99,
    background: 'rgba(255,255,255,0.3)',
  },
  previewClose: {
    background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: 99,
    width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', color: '#fff',
  },
  previewBody: {
    margin: 12, background: '#fff', borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  previewImg: {
    width: '100%', maxHeight: 200, objectFit: 'cover', display: 'block',
  },
  previewImgPlaceholder: {
    height: 120, background: colors.bg,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  previewContent: {
    padding: '18px 18px 22px',
  },
  previewTitle: {
    margin: '0 0 12px', fontSize: 17, fontWeight: 700, color: colors.text,
  },
  spinnerWhite: {
    display: 'inline-block', width: 14, height: 14,
    border: '2px solid rgba(255,255,255,0.35)',
    borderTopColor: '#fff', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
    marginRight: 8, verticalAlign: 'middle',
  },
  spinnerSmall: {
    display: 'inline-block', width: 16, height: 16,
    border: '2px solid ' + colors.brandLt,
    borderTopColor: colors.brand, borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};

export default SendAnnouncements;


// WEBPACK FOOTER //
// ./src/app/views/partner/announcements/SendAnnouncements.js